import Vue from "vue"
import VueRouter from "vue-router"

// Routes
import {canNavigate} from "@/libs/acl/routeProtection"
import {isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser} from "@/auth/utils"
import apps from "./routes/apps"
import dashboard from "./routes/dashboard"
import uiElements from "./routes/ui-elements/index"
import pages from "./routes/pages"
import chartsMaps from "./routes/charts-maps"
import formsTable from "./routes/forms-tables"
import others from "./routes/others"
import analytics from "./routes/analytics"
import clients from "./routes/clients"
import appsAndPages from "./routes/apps-and-pages"


Vue.use(VueRouter)

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    routes: [
        {path: "/", name: "main", component: () => import("@/views/main/Main.vue")},
        ...apps,
        ...dashboard,
        ...pages,
        ...chartsMaps,
        ...formsTable,
        ...uiElements,
        ...analytics,
        ...clients,
        ...appsAndPages,
        ...others,
        {
            path: "*",
            redirect: "error-404",
        },
    ],
})

const appLoading = document.getElementById("loading-bg")

router.beforeEach((to, _, next) => {
    const isLoggedIn = isUserLoggedIn();
    // const isLoggedIn = true;

    // document.getElementById('loader').classList.remove('hidden')

    // if (!canNavigate(to)) {
    //     // Redirect to login if not logged in
    // if (!isLoggedIn) return next({name: 'auth-login'})
    //
    //     // If logged in => not authorized
    //     return next({name: 'misc-not-authorized'})
    // }

    // const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "block"
    }
    if (to.meta.authRequired) {
        if (!isLoggedIn) {
            // router.push({path: '/login'})
            return next({name: "auth-login"})
        }
    }

    return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    // const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        // appLoading.style.display = 'none'
    }
})

export default router
